const types = {
    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',
    CLEAR_USER: 'CLEAR_USER',
    UPDATE_INTENTOS: 'UPDATE_INTENTOS',
    
}
export default types;
